/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type NameCell_ConfigurationFragment = { __typename: 'ConfigurationModel', id: string, name: string };

export const NameCell_ConfigurationFragmentDoc = gql`
    fragment NameCell_configuration on ConfigurationModel {
  id
  name
}
    `;